import { render } from "./ZhongyikeView.vue?vue&type=template&id=7567c75a&scoped=true"
import script from "./ZhongyikeView.vue?vue&type=script&lang=js"
export * from "./ZhongyikeView.vue?vue&type=script&lang=js"

import "./ZhongyikeView.vue?vue&type=style&index=0&id=7567c75a&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7567c75a"]])

export default __exports__